import { NgModule } from '@angular/core';

import { BootstrapIconsModule } from 'ng-bootstrap-icons';
import { Arrow90degRight, ArrowDown, ArrowLeft, ArrowLeftRight, ArrowRepeat, ArrowUp, Bandaid, Book, Bookmark, BoundingBox, BoxArrowInDown, BoxArrowRight, Calculator, CaretLeft, CaretRight, ChatLeftText, Check, Check2Square, DashLg, Download, Eraser, ExclamationTriangleFill, FileEarmarkArrowDown, FileEarmarkArrowUp, FileEarmarkSpreadsheet, FilePdf, FileText, FolderMinus, FolderPlus, Funnel, Gear, Geo, GeoAlt, GeoAltFill, House, InfoCircle, LightningFill, List, ListUl, Map, Paperclip, Pen, Pencil, PersonBadge, PersonCircle, Plus, PlusLg, Printer, Save, Search, Speedometer2, Textarea, Trash, Upload, Wifi, WifiOff, X, XCircle, XSquareFill } from 'ng-bootstrap-icons/icons';

// Select some icons (use an object, not an array)
const icons = {
	Arrow90degRight,
	ArrowDown,
	ArrowLeft,
	ArrowLeftRight,
	ArrowRepeat,
	ArrowUp,
	Bandaid,
	Book,
	Bookmark,
	BoundingBox,
	BoxArrowInDown,
	BoxArrowRight,
	Calculator,
	CaretLeft,
	CaretRight,
	ChatLeftText,
	Check,
	Check2Square,
	DashLg,
	Download,
	Eraser,
	ExclamationTriangleFill,
	FileEarmarkArrowDown,
	FileEarmarkArrowUp,
	FileEarmarkSpreadsheet,
	FilePdf,
	FileText,
	FolderMinus,
	FolderPlus,
	Funnel,
	Gear,
	Geo,
	GeoAlt,
	GeoAltFill,
	House,
	InfoCircle,
	LightningFill,
	List,
	ListUl,
	Map,
	Paperclip,
	Pen,
	Pencil,
	PersonBadge,
	PersonCircle,
	Plus,
	PlusLg,
	Printer,
	Save,
	Search,
	Speedometer2,
	Textarea,
	Trash,
	Upload,
	Wifi,
	WifiOff,
	X,
	XCircle,
	XSquareFill
};

@NgModule({
	imports: [
		BootstrapIconsModule.pick(icons)
	],
	exports: [
		BootstrapIconsModule
	]
})
export class IconsModule { }
